import { z } from 'zod';
export const sayfalamaSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(20),
});
export const sayfalanmisSonuc = (item) => z.object({
    veriler: z.array(item),
    sayfa: z.number().int(),
    boyut: z.number().int(),
    toplam: z.number().int(),
});
//# sourceMappingURL=sayfalama.js.map